import React from 'react';
import { DefaultTable } from 'src/components';
import { mockMessage } from './mocks/messages.mock';

const columns = [
  {
    name: 'Date',
    selector: (row: any) => row.date,
    sortable: true,
    sortField: 'date',
    width: '120px',
  },
  {
    name: 'Notes',
    selector: (row: any) => row.message,
    width: '360px',
  },
];

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      font: 'normal normal bold 16px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 14px Biotif',
      color: '#1B1D35',
      borderRadius: '5px',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      justifyContent: 'left',
      '&:nth-of-type(5)': {
        justifyContent: 'right',
      },
    },
  },
  pagination: {
    style: {
      border: 'none',
    },
  },
};

export const MessagesManagerTable: React.FC = () => (
  <DefaultTable columns={columns} data={mockMessage} customStyles={customStyles} />
);
